require("bootstrap/dist/css/bootstrap.min.css"); // Load Bootstrap first
require("./bootstrap-options.scss"); // Then custom Bootstrap options
require("./src/components/variables.css");
require("./src/components/global.css");
require("animate.css/animate.compat.css");
require("react-alice-carousel/lib/alice-carousel.css");

//on route change(selecting other tabs), scrolls page to top
exports.onPreRouteUpdate = () => {
  window.scrollTo(0, 0)
}

//on refresh, scrolls page to top
exports.shouldUpdateScroll = () => {
  return false
}

//on refresh, scrolls page to top
exports.onInitialClientRender = () => {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
  window.scrollTo(0, 0);
};